<div class="flex h-screen bg-gray-50">
  <!-- Sidebar Navigation - Only show on authenticated routes -->
  <app-side-nav
    *ngIf="shouldShowLayout()"
    [activeRoute]="currentRoute"
    [isOpen]="isSidebarOpen"
    (sidebarClose)="onSidebarClose()"
  ></app-side-nav>

  <!-- Main Content Area -->
  <div class="flex-1 flex flex-col overflow-auto">
    <!-- Page Header - Only show when authenticated -->
    <app-page-header
      *ngIf="shouldShowLayout()"
      [showHamburger]="true"
      [greeting]="greeting"
      [userProfile]="userProfile!"
      (sidebarToggle)="onSidebarToggle()"
    ></app-page-header>

    <!-- Router Outlet -->
    <router-outlet></router-outlet>
  </div>
</div>
